import { cleanCnpjOrCpf } from './document.util';

/**
 * Remove a formatação de um número de registro (CPF ou CNPJ).
 * CNPJ pode ser alfanumérico (RFB): preserva letras em maiúsculas; para
 * CPF/CAEPF/CNPJ numérico o resultado é idêntico ao antigo `replace(/\D/g, '')`.
 * @returns String normalizada (`[A-Z0-9]`) ou string vazia se inválida
 */
export function removeFormatRegisterNumber(
  value: string | null | undefined
): string {
  if (!value || value.trim() === '') {
    return '';
  }

  return cleanCnpjOrCpf(value);
}
